// extracted by mini-css-extract-plugin
export default {"collapse":"ShowCandidateInterviews_collapse__5q9Ed"};